import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import Pagefirst from "./Pagefirst";
import PageSecond from "./PageSecond";
import Appointment from "./Appointment";
import Department from "./Department";
import Calendar from "./Calendar";
import Addpatient from "./Addpatient";
import { AppointmentContext } from "../context/AppointmentContext";

function Dashboard() {
  const { currentStep, handleNavigation } = useContext(AppointmentContext);
  const navigate = useNavigate();

  return (
    <div className="page">
      <div className="page-main">
        <Header />

        <div className="my-1 my-md-1">
          <div className="container py-5">
            <div className="row g-4 mt-5">
              {/* Instruction Card */}
              <div className="col-12 col-md-10 col-lg-6 mx-auto mb-4">
                <div className="card shadow-sm border-0 rounded-4">
                  <div className="card-body p-4">
                    <h2 className="text-center fw-normal">
                      Need an appointment?
                    </h2>
                    <h4 className="text-center fw-normal">
                      Follow the simple steps below and get your appointment fixed online!
                    </h4>

                    <ul className="list-unstyled mt-4 px-3 px-md-5">
                      {[
                        { icon: "hospital-alt", text: "Select Hospital" },
                        { icon: "check-circle", text: "Select Mode of Appointment" },
                        { icon: "check-circle", text: "Select Appointment Type" },
                        { icon: "hospital-alt", text: "Select Department" },
                        { icon: "calendar-alt", text: "Select Date of Appointment" },
                        { icon: "check-circle", text: "Register/Login" },
                        { icon: "comment-dots", text: "Get Confirmation SMS" },
                      ].map((item, index) => (
                        <li
                          key={index}
                          className="mb-3 d-flex align-items-start"
                          style={{ fontSize: "18px", fontWeight: 300 }}
                        >
                          <i
                            className={`fa fa-${item.icon} text-primary me-3`}
                            style={{ width: "20px", textAlign: "center" }}
                          ></i>
                          <span>{item.text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Dynamic Step Content */}
              <div className="col-lg-6">
                {currentStep === "pageFirst" && (
                  <Pagefirst
                    onNext={() => handleNavigation("pageSecond")}
                    onReset={() => handleNavigation("pageFirst")}
                  />
                )}

                {currentStep === "pageSecond" && (
                  <PageSecond
                    onNext={() => handleNavigation("appointment")}
                    onPrevious={() => handleNavigation("pageFirst")}
                    onReset={() => handleNavigation("pageFirst")}
                  />
                )}

                {currentStep === "appointment" && (
                  <Appointment
                    onNext={() => handleNavigation("department")}
                    onPrevious={() => handleNavigation("pageSecond")}
                    onReset={() => handleNavigation("pageFirst")}
                  />
                )}

                {currentStep === "department" && (
                  <Department
                    onNext={() => handleNavigation("calendar")}
                    onPrevious={() => handleNavigation("appointment")}
                    onReset={() => handleNavigation("pageFirst")}
                  />
                )}

                {currentStep === "calendar" && (
                  <Calendar
                    onNext={() => navigate("/login")}
                    onPrevious={() => handleNavigation("department")}
                    onReset={() => handleNavigation("pageFirst")}
                  />
                )}

                {currentStep === "addpatient" && (
                  <Addpatient
                    onNext={() => navigate("/login")}
                    onPrevious={() => handleNavigation("calendar")}
                    onReset={() => handleNavigation("pageFirst")}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Dashboard;
